import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';

export const storeFinderTranslations: TranslationResources = {
  en,
};

export const storeFinderTranslationChunksConfig: TranslationChunksConfig = {
  storeFinder: ['storeFinder'],
};
